import React, { useState, useEffect } from 'react';
import {
  Box,
  //Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
  // Divider,
  Avatar,
  Button,
  Snackbar,
  Fab,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  TextField,
  FormGroup,
  RadioGroup,
  Radio,
  FormLabel,
} from '@mui/material';
import {
  AccountBalanceWallet as WalletIcon,
  //TrendingUp as TrendingUpIcon,
  //MonetizationOn as MoneyIcon,
  Receipt as ReceiptIcon,
  //AccountBalance as BalanceIcon,
  //CreditCard as CreditCardIcon,
  Add,
  Close as CloseIcon,
  Visibility as VisibilityIcon,
  PictureAsPdf,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';
import { toast } from 'react-toastify';

import clienteCreditoService, {
  ClienteCredito,
  EstatisticasCreditos
} from '../../services/clienteCreditoService';
import invoiceService from '../../services/invoiceService';
import InvoicesTable from '../InvoicesTable';
import PaymentForm from '../forms/InvoicePaymentForm';
import InvoiceMultipleForm from '../forms/InvoiceMultipleForm';
import RenegociarFaturaModal from '../modals/RenegociarFaturaModal';
import { Invoice, Contract } from '../../types';
import { contractService } from '../../services/contractService';
import { relatorioPdfService } from '../../services/relatorioPdfService';
import SysDateRangePicker from '../SysDateRangePicker';
//import { InvoicePaymentData } from '../forms/InvoicePaymentForm';
import { useInvoiceActions } from '../../hooks/useInvoiceActions';
import Swal from 'sweetalert2';
import { formatarData, formatarDataHora, formatarValor } from '../../utils/formatToView';
import { calculateFaturaResumo, validateInvoiceNumericValue } from '../../utils/invoiceResumoUtils';
import { CobrancaFinanceiroService } from '../../services/CobrancaFinanceiroService';
import { CobrancaFinanceiro } from '../../types';
import GerenciarCobrancaModal from '../../pages/financeiro/components/GerenciarCobrancaModal';
import { usePermissions } from '../../contexts/AuthContext';

interface ClientFinanceiroProps {
  clienteId: number;
}

const ClientFinanceiro: React.FC<ClientFinanceiroProps> = ({ clienteId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { can } = usePermissions();
  const podeDeletarFatura = can('financeiro.faturas.deletar');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [creditosDisponiveis, setCreditosDisponiveis] = useState<ClienteCredito[]>([]);
  const [estatisticasCreditos, setEstatisticasCreditos] = useState<EstatisticasCreditos | null>(null);
  const [resumoFaturas, setResumoFaturas] = useState({
    total: 0,
    pagas: 0,
    pendentes: 0,
    vencidas: 0,
    valorTotal: 0,
    valorPendente: 0,
    valorVencidas: 0,
    valorPago: 0
  });
  const [faturas, setFaturas] = useState<Invoice[]>([]);
  const [contratos, setContratos] = useState<Contract[]>([]);
  const [statusFilter, setStatusFilter] = useState<string>('todos');
  const [separarPorContrato, setSepararPorContrato] = useState<boolean>(false);


  // Estados para o modal de pagamento
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedInvoiceForPayment, setSelectedInvoiceForPayment] = useState<Invoice | null>(null);

  // Estados para alertas
  const [alert, setAlert] = useState<{ type: 'success' | 'error' | 'warning'; message: string } | null>(null);

  // Estados para ações de fatura
  // const [selectedInvoice, setSelectedInvoice] = useState<Invoice | null>(null);
  //const [bulkCancelMode, setBulkCancelMode] = useState(false);
  //const [bulkPrintMode, setBulkPrintMode] = useState(false);
  //const [bulkEditMode, setBulkEditMode] = useState(false);
  //const [selectedInvoices, setSelectedInvoices] = useState<number[]>([]);
  //const [selectedInvoicesData, setSelectedInvoicesData] = useState<Invoice[]>([]);

  // Estados para modais de impressão
  const [selectedInvoiceForPrint, setSelectedInvoiceForPrint] = useState<Invoice | null>(null);

  // Estados para modal de créditos
  const [creditosModalOpen, setCreditosModalOpen] = useState(false);

  // Estados para modal de renegociação
  const [renegociarModalOpen, setRenegociarModalOpen] = useState(false);
  const [renegociarIds, setRenegociarIds] = useState<number[]>([]);

  // Estados para cobranças ativas do cliente
  const [cobrancasAtivas, setCobrancasAtivas] = useState<CobrancaFinanceiro[]>([]);
  const [gerenciarCobrancaOpen, setGerenciarCobrancaOpen] = useState(false);
  const [selectedCobrancaId, setSelectedCobrancaId] = useState<number | null>(null);

  // Modal Extrato Financeiro PDF
  const [extratoModalOpen, setExtratoModalOpen] = useState(false);
  const [extratoContratos, setExtratoContratos] = useState<Contract[]>([]);
  const [extratoLoadingContratos, setExtratoLoadingContratos] = useState(false);
  const [extratoTipo, setExtratoTipo] = useState<'cliente' | 'contrato'>('cliente');
  const [extratoContratoSelecionado, setExtratoContratoSelecionado] = useState<Contract | null>(null);
  const [extratoSomentePagas, setExtratoSomentePagas] = useState(true);
  const [extratoExibirValorFatura, setExtratoExibirValorFatura] = useState(true);
  const [extratoExibirValorPago, setExtratoExibirValorPago] = useState(false);
  const [extratoDateRange, setExtratoDateRange] = useState<{ startDate: Date | null; endDate: Date | null }>({ startDate: null, endDate: null });
  const [extratoGerando, setExtratoGerando] = useState(false);
  const [deleteCancelledMode, setDeleteCancelledMode] = useState(false);

  // Hook para ações de fatura
  const {
    // Estados para modais
    //viewModalOpen,
    //viewInvoice,

    // Estados para ações em massa
    //bulkCancelMode: hookBulkCancelMode,
    //bulkPrintMode: hookBulkPrintMode,
    bulkEditMode: hookBulkEditMode,
    selectedInvoices: hookSelectedInvoices,
    selectedInvoicesData: hookSelectedInvoicesData,

    // Estados para modais
    formOpen: hookFormOpen,

    // Handlers para ações
    //handleViewInvoice,
    //handleCloseViewModal,
    //handleEditInvoice,
    //handleEditFromView,
    //handleCancelInvoice,
    //handleCheckGatewayStatus,
    //handleProcessBoleto,

    // Handlers para ações em massa
    //handleBulkCancelMode,
    //handleBulkPrintMode,
    //handleBulkEditMode,
    //handleCancelBulkMode,
    handleSelectInvoice,
    handleMassCancel,
    handleMassPrint,
    handleMassEdit,
    handleMassDelete,

    // Handlers para gerenciar modais
    setFormOpen: hookSetFormOpen,
    setSelectedInvoice: hookSetSelectedInvoice,
    handleCancelBulkMode,

    // Computed
    hasSelectedInvoices
  } = useInvoiceActions({
    showAlert: (type, message) => setAlert({ type, message }),
    loadInvoices: () => loadData()
  });

  // Função para validar e limpar valores numéricos
  const validateNumericValue = validateInvoiceNumericValue;

  // Função para atualizar o resumo com valores validados
  const updateResumoFaturas = (newResumo: any) => {
    const validatedResumo = {
      total: validateNumericValue(newResumo.total),
      pagas: validateNumericValue(newResumo.pagas),
      pendentes: validateNumericValue(newResumo.pendentes),
      vencidas: validateNumericValue(newResumo.vencidas),
      valorTotal: validateNumericValue(newResumo.valorTotal),
      valorPendente: validateNumericValue(newResumo.valorPendente),
      valorVencidas: validateNumericValue(newResumo.valorVencidas),
      valorPago: validateNumericValue(newResumo.valorPago)
    };

    setResumoFaturas(validatedResumo);
  };

  // Função para abrir modal de pagamento
  const handleReceivePayment = (invoice: Invoice) => {
    setSelectedInvoiceForPayment(invoice);
    setPaymentModalOpen(true);
  };

  // Função para fechar modal de pagamento
  const handleClosePaymentModal = () => {
    setPaymentModalOpen(false);
    setSelectedInvoiceForPayment(null);
  };

  // Função para criar nova fatura
  const handleCreateInvoice = () => {
    hookSetSelectedInvoice(null);
    hookSetFormOpen(true);
  };

  // Função para fechar formulário
  const handleCloseForm = () => {
    hookSetFormOpen(false);
    hookSetSelectedInvoice(null);
  };

  const handleDeleteCancelledClick = async () => {
    if (!deleteCancelledMode) {
      handleCancelBulkMode();
      if (statusFilter === 'ocultar_cancelados') {
        setStatusFilter('todos');
      }
      setDeleteCancelledMode(true);
      return;
    }

    if (hasSelectedInvoices) {
      await handleMassDelete(hookSelectedInvoices);
      setDeleteCancelledMode(false);
      return;
    }

    setDeleteCancelledMode(false);
  };

  // Função para salvar fatura
  const handleSaveInvoice = async () => {
    handleCloseForm();
    // Aguardar um momento para garantir que as faturas foram persistidas no BD
    setTimeout(() => {
      loadData(); // Recarregar faturas do BD
    }, 500);
  };

  // Handlers para impressão em massa
  const handleMassPrintClick = async () => {
    try {
      const printType = await handleMassPrint();

      if (printType === 'fatura' || printType === 'carne' || printType === 'capa_carne') {
        if (hookSelectedInvoices.length > 0) {
          // Mostrar alert de carregamento
          Swal.fire({
            title: 'Gerando PDF...',
            text: 'Aguarde enquanto geramos o documento',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });

          const blob = await invoiceService.imprimirPDF(hookSelectedInvoices, printType as 'fatura' | 'carne' | 'capa_carne');
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          Swal.close();
        } else {
          setAlert({ type: 'warning', message: 'Nenhuma fatura selecionada' });
        }
      }
    } catch (error) {
      console.error('Erro ao processar impressão em massa:', error);
      setAlert({ type: 'error', message: 'Erro ao gerar PDF das faturas' });
      Swal.close();
    }
  };

  // Handlers para modal de créditos
  const handleOpenCreditosModal = () => {
    setCreditosModalOpen(true);
  };

  const handleCloseCreditosModal = () => {
    setCreditosModalOpen(false);
  };

  const handleOpenExtratoModal = async () => {
    setExtratoModalOpen(true);
    setExtratoTipo('cliente');
    setExtratoContratoSelecionado(null);
    setExtratoSomentePagas(true);
    setExtratoExibirValorFatura(true);
    setExtratoExibirValorPago(false);
    setExtratoDateRange({ startDate: null, endDate: null });
    if (contratos.length > 0) {
      setExtratoContratos(contratos);
      setExtratoLoadingContratos(false);
    } else {
      setExtratoLoadingContratos(true);
      try {
        const response = await contractService.getByClientId(clienteId, { limit: 100 });
        setExtratoContratos(response.data || []);
      } catch {
        setExtratoContratos([]);
      } finally {
        setExtratoLoadingContratos(false);
      }
    }
  };

  const handleCloseExtratoModal = () => {
    setExtratoModalOpen(false);
  };

  const dateToYmd = (d: Date | null): string => {
    if (!d) return '';
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleGerarExtrato = async () => {
    if (extratoTipo === 'contrato' && !extratoContratoSelecionado) {
      toast.warning('Selecione um contrato para exportar.');
      return;
    }
    setExtratoGerando(true);
    try {
      await relatorioPdfService.exportarExtratoFinanceiro({
        cliente_id: clienteId,
        contrato_id: extratoTipo === 'contrato' ? extratoContratoSelecionado!.id : undefined,
        somente_pagas: extratoSomentePagas,
        exibir_valor_fatura: extratoExibirValorFatura,
        exibir_valor_pago: extratoExibirValorPago,
        data_inicio: dateToYmd(extratoDateRange.startDate) || undefined,
        data_fim: dateToYmd(extratoDateRange.endDate) || undefined,
      });
      setExtratoModalOpen(false);
    } catch {
      // Toast já tratado no service
    } finally {
      setExtratoGerando(false);
    }
  };




  // Função para mostrar alertas
  const showAlert = (type: 'success' | 'error' | 'warning', message: string) => {
    setAlert({ type, message });
  };



  useEffect(() => {
    loadData();
  }, [clienteId]);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Carregar dados em paralelo
      const [
        creditosData,
        estatisticasData,
        faturasData,
        cobrancasData,
        contratosData
      ] = await Promise.all([
        clienteCreditoService.getCreditosDisponiveis(clienteId).catch((err) => {
          console.error('❌ Erro ao carregar créditos:', err);
          return [];
        }),
        clienteCreditoService.getEstatisticasCreditos(clienteId).catch((err) => {
          console.error('❌ Erro ao carregar estatísticas:', err);
          return null;
        }),
        invoiceService.getInvoicesByClient(clienteId).catch((err) => {
          console.error('❌ Erro ao carregar faturas:', err);
          return { data: [] };
        }),
        CobrancaFinanceiroService.getAll({ cliente_id: clienteId }).catch((err) => {
          console.error('❌ Erro ao carregar cobranças:', err);
          return [];
        }),
        contractService.getByClientId(clienteId, { limit: 100 }).catch((err) => {
          console.error('❌ Erro ao carregar contratos:', err);
          return { data: [] };
        })
      ]);

      setCreditosDisponiveis(creditosData);
      setEstatisticasCreditos(estatisticasData);
      setContratos(contratosData?.data || []);

      // Filtrar cobranças que não estão canceladas/finalizadas
      const cobrancasArray = Array.isArray(cobrancasData) ? cobrancasData : (cobrancasData as any)?.data || [];
      const ativas = cobrancasArray.filter(
        (c: CobrancaFinanceiro) => c.status !== 'cancelado' && c.status !== 'finalizado'
      );
      setCobrancasAtivas(ativas);

      if (faturasData && faturasData.data) {
        setFaturas(faturasData.data);

        const resumo = calculateFaturaResumo(faturasData.data);
        updateResumoFaturas(resumo);
      } else {
        console.warn('⚠️ Faturas não encontradas ou formato inválido:', faturasData);
      }

    } catch (err: any) {
      console.error('❌ Erro ao carregar dados financeiros:', err);
      setError('Erro ao carregar dados financeiros');
    } finally {
      setLoading(false);
    }
  };

  // Faturas filtradas por status
  const faturasFiltradas = React.useMemo(() => {
    if (statusFilter === 'todos') return faturas;
    if (statusFilter === 'ocultar_cancelados') return faturas.filter(f => f.status !== 'cancelado');
    return faturas.filter(f => f.status === statusFilter);
  }, [faturas, statusFilter]);

  // Agrupar faturas por contrato (contrato_id)
  const invoicesByContract = React.useMemo(() => {
    const groups: Record<
      string,
      {
        contrato?: Contract;
        invoices: Invoice[];
      }
    > = {};
    const semContratoKey = '__sem_contrato__';

    faturasFiltradas.forEach((inv) => {
      const contratoId = inv.contrato_id || inv.contrato?.id;
      const contratoInfo = contratos.find((c) => c.id === contratoId) || inv.contrato;

      if (contratoId) {
        const key = contratoId.toString();
        if (!groups[key]) {
          groups[key] = {
            contrato: contratoInfo ? ({
              ...contratoInfo,
              id: contratoId,
              titulo: contratoInfo.titulo || `Contrato #${contratoId}`
            } as Contract) : ({
              id: contratoId,
              titulo: `Contrato #${contratoId}`
            } as any),
            invoices: []
          };
        }
        groups[key].invoices.push(inv);
      } else {
        if (!groups[semContratoKey]) {
          groups[semContratoKey] = {
            invoices: []
          };
        }
        groups[semContratoKey].invoices.push(inv);
      }
    });

    // Ordenar: primeiro contratos por ID, depois sem contrato vinculado no final
    const entries = Object.entries(groups);
    return entries.sort((a, b) => {
      if (a[0] === semContratoKey) return 1;
      if (b[0] === semContratoKey) return -1;
      const idA = a[1].contrato?.id || 0;
      const idB = b[1].contrato?.id || 0;
      return idA - idB;
    });
  }, [faturasFiltradas, contratos]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
        <Typography component="span" sx={{ ml: 2 }}>
          <Typography
            component="span"
            sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'primary.main' }}
            onClick={loadData}
          >
            Tentar Novamente
          </Typography>
        </Typography>
      </Alert>
    );
  }

  return (
    <Box>
      {/* Seção de Resumo das Faturas */}
      <Grid container spacing={1} sx={{ mb: 1 }}>
        {/* Resumo das Faturas */}
        <Grid item xs={12} >
          <Card sx={{ height: '100%' }}>
            <CardContent style={{ padding: 5 }}>
              <Grid container spacing={1}>
                <Grid item xs={6} sm={4} md={4}>
                  <Box sx={{
                    p: 0.5,
                    border: 1,
                    borderColor: 'divider',
                    bgcolor: (theme) => theme.palette.mode === 'dark'
                      ? 'rgba(255, 255, 255, 0.05)'
                      : 'grey.50',
                    borderRadius: 2
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Pagas:</Typography>
                      <Typography variant="body2" fontWeight="600" color="success.main">
                        {resumoFaturas.pagas}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Pendentes:</Typography>
                      <Typography variant="body2" fontWeight="600" color="warning.main">
                        {resumoFaturas.pendentes}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Vencidas:</Typography>
                      <Typography variant="body2" fontWeight="600" color="error.main">
                        {resumoFaturas.vencidas}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} sm={4} md={4}>
                  <Box sx={{
                    p: 0.5,
                    border: 1,
                    borderColor: 'divider',
                    bgcolor: (theme) => theme.palette.mode === 'dark'
                      ? 'rgba(255, 255, 255, 0.05)'
                      : 'grey.50',
                    borderRadius: 2
                  }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Total Geral:</Typography>
                      <Typography variant="body2" fontWeight="600">
                        {formatarValor(resumoFaturas.valorTotal)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Total Vencido:</Typography>
                      <Typography variant="body2" fontWeight="600" color="error.main">
                        {formatarValor(resumoFaturas.valorVencidas)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.3 }}>
                      <Typography variant="body2">Total Pago:</Typography>
                      <Typography variant="body2" fontWeight="600" color="success.main">
                        {formatarValor(resumoFaturas.valorPago)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* Créditos Disponíveis */}
                <Grid item xs={12} sm={4} md={4} >
                  <Card sx={{ cursor: 'pointer', '&:hover': { boxShadow: 3 } }} onClick={handleOpenCreditosModal}>
                    <CardContent style={{ padding: 5 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ bgcolor: 'success.main', mr: 2 }}>
                            <WalletIcon />
                          </Avatar>
                          <Box>
                            <Typography color="text.secondary" variant="body2">
                              Créditos Disponíveis
                            </Typography>
                            <Typography variant="h5" color="success.main">
                              {estatisticasCreditos ? formatarValor(Number(estatisticasCreditos.totalDisponivel) || 0) : 'R$ 0,00'}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
                          <VisibilityIcon fontSize="small" />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Alerta de Cobranças Ativas */}
      {cobrancasAtivas.length > 0 && (
        <Alert
          severity="warning"
          sx={{ mb: 1 }}
          icon={false}
        >
          <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5 }}>
            ⚠️ Este cliente possui {cobrancasAtivas.length} cobrança(s) ativa(s):
          </Typography>
          {cobrancasAtivas.map((cobranca) => (
            <Box key={cobranca.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.3 }}>
              <Typography
                variant="body2"
                color="primary"
                sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
                onClick={() => {
                  setSelectedCobrancaId(cobranca.id);
                  setGerenciarCobrancaOpen(true);
                }}
              >
                Cobrança #{cobranca.id}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                — Status: <strong>{cobranca.status.replace(/_/g, ' ')}</strong> | Valor: <strong>{formatarValor(cobranca.valor_original)}</strong>
              </Typography>
            </Box>
          ))}
        </Alert>
      )}

      {/* Tabela de Faturas */}
      <Card>
        <CardContent sx={{ padding: 1 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2">
                <ReceiptIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                Histórico de Faturas
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<PictureAsPdf />}
                onClick={handleOpenExtratoModal}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
              >
                Financeiro PDF
              </Button>
            </Box>

            {/* Botões de Ação */}
            <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={separarPorContrato}
                    onChange={(e) => setSepararPorContrato(e.target.checked)}
                    size="small"
                  />
                }
                label={<Typography variant="body2" sx={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>Separar por Contrato</Typography>}
                sx={{ mr: 0.5, my: 0 }}
              />
              <FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="status-filter-label" sx={{ fontSize: '0.8rem' }}>Status</InputLabel>
                <Select
                  labelId="status-filter-label"
                  id="status-filter"
                  value={statusFilter}
                  label="Status"
                  onChange={(e) => setStatusFilter(e.target.value)}
                  size="small"
                  sx={{ height: 30, fontSize: '0.8rem' }}
                >
                  <MenuItem dense value="todos">Todos</MenuItem>
                  <MenuItem dense value="ocultar_cancelados">Ocultar Cancelados</MenuItem>
                  <MenuItem dense value="aberto">Aberto</MenuItem>
                  <MenuItem dense value="pago">Pago</MenuItem>
                  <MenuItem dense value="vencido">Vencido</MenuItem>
                  <MenuItem dense value="parcialmente_pago">Parcialmente Pago</MenuItem>
                  <MenuItem dense value="cancelado">Cancelado</MenuItem>
                  <MenuItem dense value="premiado">Premiado</MenuItem>
                </Select>
              </FormControl>
              <Button
                variant="outlined"
                color="error"
                disabled={deleteCancelledMode || !hasSelectedInvoices}
                onClick={() => handleMassCancel(hookSelectedInvoices)}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                size="small"
              >
                Cancelar {hasSelectedInvoices && `(${hookSelectedInvoices.length})`}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                disabled={deleteCancelledMode || !hasSelectedInvoices}
                onClick={handleMassPrintClick}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                size="small"
              >
                Imprimir {hasSelectedInvoices && `(${hookSelectedInvoices.length})`}
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                disabled={deleteCancelledMode || !hasSelectedInvoices}
                onClick={handleMassEdit}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                size="small"
              >
                Editar {hasSelectedInvoices && `(${hookSelectedInvoices.length})`}
              </Button>
              <Button
                variant="outlined"
                color="info"
                disabled={deleteCancelledMode || !hasSelectedInvoices}
                onClick={() => {
                  setRenegociarIds(hookSelectedInvoices);
                  setRenegociarModalOpen(true);
                }}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                size="small"
              >
                Renegociar {hasSelectedInvoices && `(${hookSelectedInvoices.length})`}
              </Button>
              {podeDeletarFatura && (
                <Button
                  variant={deleteCancelledMode && hasSelectedInvoices ? 'contained' : 'outlined'}
                  color="error"
                  onClick={handleDeleteCancelledClick}
                  sx={{ display: { xs: 'none', sm: 'flex' } }}
                  size="small"
                >
                  {deleteCancelledMode && hasSelectedInvoices
                    ? `Deletar (${hookSelectedInvoices.length})`
                    : 'Deletar Canceladas'}
                </Button>
              )}
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={handleCreateInvoice}
                sx={{ display: { xs: 'none', sm: 'flex' } }}
                size="small"
              >
                Nova Fatura
              </Button>
            </Box>
          </Box>

          {!separarPorContrato ? (
            <InvoicesTable
              invoices={faturasFiltradas}
              loading={loading}
              error={error}
              showContractColumn={true}
              showClientColumn={false}
              showGatewayColumn={true}
              onReceivePayment={handleReceivePayment}
              onInvoiceUpdated={loadData}
              showAlert={(type, message) => setAlert({ type, message })}
              onSelectInvoice={handleSelectInvoice}
              selectedInvoices={hookSelectedInvoices}
              selectionMode={deleteCancelledMode ? 'delete_cancelled' : 'default'}
              onRenegociar={(ids) => {
                setRenegociarIds(ids);
                setRenegociarModalOpen(true);
              }}
            />
          ) : invoicesByContract.length === 0 ? (
            <Card variant="outlined" sx={{ mt: 1, p: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Nenhuma fatura encontrada.
              </Typography>
            </Card>
          ) : (
            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {invoicesByContract.map(([groupKey, { contrato, invoices: groupInvoices }]) => {
                const resumoGrupo = calculateFaturaResumo(groupInvoices);
                return (
                  <Card key={groupKey} variant="outlined" sx={{ overflow: 'hidden' }}>
                    <Box
                      sx={{
                        px: 1.5,
                        py: 0.75,
                        bgcolor: 'action.hover',
                        borderBottom: 1,
                        borderColor: 'divider',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 0.75
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                        <Box component="span" sx={{ display: 'flex', '& svg': { fontSize: 18 }, color: 'primary.main' }}>
                          {contrato ? <AssignmentIcon sx={{ fontSize: 18 }} /> : <ReceiptIcon sx={{ fontSize: 18 }} />}
                        </Box>
                        <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                          {contrato
                            ? `Contrato #${contrato.id} - ${contrato.titulo || 'Sem título'}`
                            : 'Faturas sem contrato vinculado'}
                        </Typography>
                        {contrato?.status && (
                          <Chip
                            label={contrato.status.replace(/_/g, ' ')}
                            size="small"
                            color={
                              contrato.status === 'ativo' ? 'success' :
                              contrato.status === 'bloqueado' ? 'error' :
                              contrato.status === 'cancelado' ? 'default' : 'warning'
                            }
                            variant="outlined"
                            sx={{ height: 20, fontSize: '0.7rem', textTransform: 'capitalize' }}
                          />
                        )}
                        <Chip
                          label={`${groupInvoices.length} fatura${groupInvoices.length !== 1 ? 's' : ''}`}
                          size="small"
                          variant="outlined"
                          sx={{ height: 20, fontSize: '0.7rem' }}
                        />
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                        <Typography variant="caption" color="text.secondary">
                          Total: <strong>{formatarValor(resumoGrupo.valorTotal)}</strong>
                        </Typography>
                        {resumoGrupo.valorVencidas > 0 && (
                          <Typography variant="caption" color="error.main" fontWeight="600">
                            Vencido: {formatarValor(resumoGrupo.valorVencidas)}
                          </Typography>
                        )}
                        {resumoGrupo.valorPendente > 0 && (
                          <Typography variant="caption" color="warning.main" fontWeight="600">
                            Pendente: {formatarValor(resumoGrupo.valorPendente)}
                          </Typography>
                        )}
                        {resumoGrupo.valorPago > 0 && (
                          <Typography variant="caption" color="success.main" fontWeight="600">
                            Pago: {formatarValor(resumoGrupo.valorPago)}
                          </Typography>
                        )}
                      </Box>
                    </Box>

                    <InvoicesTable
                      invoices={groupInvoices}
                      loading={false}
                      error={null}
                      showContractColumn={false}
                      showClientColumn={false}
                      showGatewayColumn={true}
                      onReceivePayment={handleReceivePayment}
                      onInvoiceUpdated={loadData}
                      showAlert={(type, message) => setAlert({ type, message })}
                      onSelectInvoice={handleSelectInvoice}
                      selectedInvoices={hookSelectedInvoices}
                      selectionMode={deleteCancelledMode ? 'delete_cancelled' : 'default'}
                      onRenegociar={(ids) => {
                        setRenegociarIds(ids);
                        setRenegociarModalOpen(true);
                      }}
                    />
                  </Card>
                );
              })}
            </Box>
          )}
        </CardContent>
      </Card>

      {/* FAB para mobile */}
      {isMobile && (
        <Fab
          color="primary"
          aria-label="add"
          sx={{
            position: 'fixed',
            bottom: 86, // Footer height (70px) + spacing (16px) = 86px
            right: 16,
            zIndex: theme.zIndex.appBar - 1, // Abaixo do FAB do dashboard mas acima do footer
          }}
          onClick={handleCreateInvoice}
        >
          <Add />
        </Fab>
      )}

      {/* Formulário de Fatura */}
      <InvoiceMultipleForm
        open={hookFormOpen}
        onClose={handleCloseForm}
        //invoice={selectedInvoice}
        onSubmit={handleSaveInvoice}
        title={hookBulkEditMode ? `Editar ${hookSelectedInvoices.length} Fatura(s)` : "Nova Fatura"}
        clientId={clienteId}
        isEditMode={hookBulkEditMode}
        selectedInvoicesData={hookBulkEditMode ? hookSelectedInvoicesData : undefined}
      />



      {/* Modal de Pagamento */}
      {selectedInvoiceForPayment && (
        <PaymentForm
          open={paymentModalOpen}
          onClose={handleClosePaymentModal}
          invoice={selectedInvoiceForPayment}
          onSuccess={(paymentData, invoice) => {
            handleClosePaymentModal();
            loadData();
          }}
          onError={(error) => {
            console.error('❌ Erro no pagamento:', error);
          }}
          onCancel={() => {}}
          reloadDataOnSuccess={loadData}
          autoCloseOnSuccess={true}
        />
      )}

      {/* Modal de Créditos Disponíveis */}
      <Dialog
        open={creditosModalOpen}
        onClose={handleCloseCreditosModal}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <WalletIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
              <Typography variant="h6">
                Créditos Disponíveis para Uso
              </Typography>
            </Box>
            <IconButton
              aria-label="close"
              onClick={handleCloseCreditosModal}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {creditosDisponiveis.length === 0 ? (
            <Alert severity="info" sx={{ mt: 2 }}>
              Você não possui créditos disponíveis no momento.
            </Alert>
          ) : (
            <TableContainer sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Origem</TableCell>
                    <TableCell>Nível</TableCell>
                    <TableCell>Valor Original</TableCell>
                    <TableCell>Saldo Disponível</TableCell>
                    <TableCell>Criado em</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {creditosDisponiveis.map((credito) => (
                    <TableRow key={credito.id}>
                      <TableCell>
                        <Chip
                          label={clienteCreditoService.formatTipoCredito(credito.tipo)}
                          color={clienteCreditoService.getTipoCreditoColor(credito.tipo)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{credito.cliente_origem?.nome || 'N/A'}</TableCell>
                      <TableCell>Nível {credito.nivel}</TableCell>
                      <TableCell>{formatarValor(credito.valor)}</TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600" color="success.main">
                          {formatarValor(credito.saldo)}
                        </Typography>
                      </TableCell>
                      <TableCell>{formatarDataHora(credito.createdAt)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCreditosModal} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>


      {/* Modal de Renegociação */}
      <RenegociarFaturaModal
        open={renegociarModalOpen}
        onClose={() => {
          setRenegociarModalOpen(false);
          setRenegociarIds([]);
        }}
        invoiceIds={renegociarIds}
        onSuccess={() => {
          loadData();
          setAlert({ type: 'success', message: 'Renegociação realizada com sucesso!' });
        }}
        onError={(msg) => setAlert({ type: 'error', message: msg })}
      />

      {/* Modal de Gerenciar Cobrança */}
      <GerenciarCobrancaModal
        open={gerenciarCobrancaOpen}
        onClose={() => setGerenciarCobrancaOpen(false)}
        cobrancaId={selectedCobrancaId}
        onSuccess={() => loadData()}
      />

      {/* Modal Extrato Financeiro PDF */}
      <Dialog
        open={extratoModalOpen}
        onClose={handleCloseExtratoModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PictureAsPdf color="error" />
          Exportar Extrato Financeiro
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: 1 }}>
            <Box>
              <FormLabel component="legend" sx={{ mb: 1, fontWeight: 600 }}>Exportar relatório de:</FormLabel>
              <RadioGroup
                row
                value={extratoTipo}
                onChange={(e) => {
                  setExtratoTipo(e.target.value as 'cliente' | 'contrato');
                  if (e.target.value === 'cliente') setExtratoContratoSelecionado(null);
                }}
              >
                <FormControlLabel value="cliente" control={<Radio />} label="Cliente (todas as faturas)" />
                <FormControlLabel value="contrato" control={<Radio />} label="Contrato específico" />
              </RadioGroup>
            </Box>

            {extratoTipo === 'contrato' && (
              <Autocomplete
                options={extratoContratos}
                getOptionLabel={(option) => `#${option.id} - ${option.titulo}`}
                value={extratoContratoSelecionado}
                onChange={(_, newValue) => setExtratoContratoSelecionado(newValue)}
                loading={extratoLoadingContratos}
                renderInput={(params) => (
                  <TextField {...params} label="Selecionar Contrato" size="small" required />
                )}
                size="small"
                noOptionsText="Nenhum contrato encontrado"
              />
            )}

            <Box>
              <FormLabel component="legend" sx={{ mb: 0.5, fontWeight: 600 }}>Opções de exibição:</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox checked={extratoSomentePagas} onChange={(e) => setExtratoSomentePagas(e.target.checked)} />}
                  label="Exibir somente faturas pagas"
                />
                <FormControlLabel
                  control={<Checkbox checked={extratoExibirValorFatura} onChange={(e) => setExtratoExibirValorFatura(e.target.checked)} />}
                  label="Exibir valor da fatura"
                />
                <FormControlLabel
                  control={<Checkbox checked={extratoExibirValorPago} onChange={(e) => setExtratoExibirValorPago(e.target.checked)} />}
                  label="Exibir valor pago da fatura"
                />
              </FormGroup>
            </Box>

            <Box>
              <FormLabel component="legend" sx={{ mb: 0.5, fontWeight: 600 }}>Período de vencimento (opcional):</FormLabel>
              <SysDateRangePicker
                label="Data Vencimento"
                value={extratoDateRange}
                onChange={(range) => setExtratoDateRange(range)}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={handleCloseExtratoModal} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={handleGerarExtrato}
            variant="contained"
            startIcon={extratoGerando ? <CircularProgress size={18} color="inherit" /> : <PictureAsPdf />}
            disabled={extratoGerando}
          >
            {extratoGerando ? 'Gerando...' : 'Gerar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar para alertas */}
      <Snackbar
        open={!!alert}
        autoHideDuration={6000}
        onClose={() => setAlert(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setAlert(null)}
          severity={alert?.type}
          sx={{ width: '100%' }}
        >
          {alert?.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ClientFinanceiro;
